module.exports = " <div class=more-categories v-bind:class=\"{'wide-view': wideView}\" v-if=categories.length _v-0a3f94f4=\"\"> <ul _v-0a3f94f4=\"\"> <li _v-0a3f94f4=\"\"><a v-on:click.prevent=onClick(null) _v-0a3f94f4=\"\">All</a></li> <li v-for=\"category in categories\" _v-0a3f94f4=\"\"> <a v-on:click.prevent=onClick(category) _v-0a3f94f4=\"\">{{category.name}}</a> </li> </ul> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-0a3f94f4!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/categories.vue
// module id = 312
// module chunks = 0